export default {
      id: "sensors__voltage-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.svg#sensors__voltage",
      toString: function () {
        return this.url;
      }
    }